/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import React, { useState, useEffect } from 'react';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  CircularProgress,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { resetPassword } from '../services/api.js';
import {
  isValidPassword,
  getPasswordErrorMessage,
} from '../utils/validation.js';

const ResetPasswordPage = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [token, setToken] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tokenParam = queryParams.get('token');
    if (tokenParam) {
      setToken(tokenParam);
    } else {
      setError(
        'Token de recuperação não encontrado. Solicite uma nova redefinição.'
      );
    }
  }, [location.search]);

  const handleSubmit = async e => {
    e.preventDefault();
    if (!password || !confirmPassword || !token) return;

    if (!isValidPassword(password)) {
      setError(getPasswordErrorMessage());
      return;
    }

    if (password !== confirmPassword) {
      setError('As senhas não conferem.');
      return;
    }

    try {
      setLoading(true);
      setError(null);
      await resetPassword(token, password, confirmPassword);
      setSuccess(true);
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (err) {
      setError(err.message || 'Erro ao redefinir a senha.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#f5f5f5',
        py: 4,
      }}
    >
      <Container maxWidth='sm'>
        <Paper
          elevation={3}
          sx={{
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: 2,
          }}
        >
          <Typography
            component='h1'
            variant='h5'
            sx={{ mb: 3, fontWeight: 'bold', color: '#1a1a1a' }}
          >
            Redefinir Senha
          </Typography>

          {!success ? (
            <Box
              component='form'
              onSubmit={handleSubmit}
              sx={{ width: '100%' }}
            >
              <TextField
                margin='normal'
                required
                fullWidth
                name='password'
                label='Nova Senha'
                type='password'
                id='password'
                autoComplete='new-password'
                value={password}
                onChange={e => setPassword(e.target.value)}
                disabled={loading || !token}
              />
              <TextField
                margin='normal'
                required
                fullWidth
                name='confirmPassword'
                label='Confirmar Nova Senha'
                type='password'
                id='confirmPassword'
                autoComplete='new-password'
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                disabled={loading || !token}
              />

              {error && (
                <Alert severity='error' sx={{ mt: 2 }}>
                  {error}
                </Alert>
              )}

              <Button
                type='submit'
                fullWidth
                variant='contained'
                sx={{ mt: 3, mb: 2, py: 1.5, fontWeight: 'bold' }}
                disabled={loading || !token}
              >
                {loading ? <CircularProgress size={24} /> : 'Redefinir Senha'}
              </Button>
            </Box>
          ) : (
            <Box sx={{ width: '100%', textAlign: 'center' }}>
              <Alert severity='success' sx={{ mb: 3 }}>
                Senha redefinida com sucesso! Você será redirecionado para o
                login.
              </Alert>
              <CircularProgress color='success' />
            </Box>
          )}
        </Paper>
      </Container>
    </Box>
  );
};

export default ResetPasswordPage;
